import React from "react";
import StartForm from "./StartForm";
import { useSelector } from "react-redux";
import { selectUser } from "store/user/selectors";

export default function Home() {
  const user = useSelector(selectUser);

  return (
    <div
      key={user?.id}
      className="flex-grow flex flex-col-reverse lg:flex-row lg:overflow-y-auto"
    >
      <div className="max-w-xl mx-auto flex-grow lg:flex lg:flex-col text-center lg:justify-center gap-4">
        <div className="">
          <h2 className="ms-auto text-3xl lg:text-5xl   font-semibold mb-8">
            <span className="text-violet-300 font-bold">HS Master</span>-ə xoş
            gəlmisiniz!
          </h2>

          <p>
            Hər bir turda sizə 8 şəkil təqdim edilir, hər biri unikal HS kodu
            ilə əlaqəlidir. Vaxt bitmədən əvvəl hər bir şəkil üçün düzgün kodu
            daxil edin. Bir kartın vaxtı bitdikdə, yeni bir şəkil görünür.
          </p>
        </div>

        <div className="my-8 flex-grow text-end lg:flex-grow-0">
          <StartForm />
        </div>
      </div>
    </div>
  );
}
